import { connect } from "react-redux";

import { PrivacyPolicy, TermsOfService } from "../../utils/utils";
import { EOrganizationType, IAppState } from "../../interfaces/interfaces";

import SplitScreenLayout from "./common/SplitScreenLayout";
import TermsAndConditionsForm from "./TermsAndConditionsForm";

const TermsAndConditions: React.FC<{ organizationType: EOrganizationType }> = ({
  organizationType,
}) => {
  const isProView =
    organizationType === EOrganizationType.PRO_VIEW_ORGANIZATION;

  const rightMessage = (
    <div className="terms-conditions-container">
      <div>
        As a user of{" "}
        {isProView ? "Brilliant ProView" : "the Brilliant Command Center"}, you
        acknowledge that this product is to be used for management purposes only
        across the smart home devices in your properties.
      </div>
      <br />
      <div>
        Information shown is covered by the&nbsp;
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="terms-conditions-link"
          href={PrivacyPolicy}
        >
          Brilliant Privacy Policy
        </a>
        &nbsp;and&nbsp;
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="terms-conditions-link"
          href={TermsOfService}
        >
          Brilliant Terms of Service
        </a>
        .
      </div>
    </div>
  );

  return (
    <SplitScreenLayout
      form={<TermsAndConditionsForm />}
      leftTitle="Before we begin your registration..."
      leftDescription=""
      rightMessage={rightMessage}
    />
  );
};

const mapStateToProps = (state: IAppState) => {
  return {
    organizationType: state.newUser.organizationType,
  };
};

export default connect(mapStateToProps)(TermsAndConditions);
